import {useQuery} from '@tanstack/react-query';
import {TypeLocalNameEnum} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {EntryPointCodeEnum} from 'presentation/constants/entryPointCodeEnum';
import {useQueryParams} from 'presentation/pages';
import {TELEMEDICINE_INFO} from '../../constants/telemedicineInfo';
import {getHealthDates} from '../../services/getHealthDates';
import {useBookingStore} from '../../store/useBookingStore';
import {UseGetHealthDatesQueryProps} from './types';
import {HEALTH_DATES_STALE_TIME} from './constants';

function useGetHealthDatesQuery({enabled, isTelemedicine}: UseGetHealthDatesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {autocompleteQuery: providerId},
	} = useQueryParams();

	const {
		specialtyCode,
		unitCode,
		subSpecialtyCode,
		cityName,
		ufCode,
		isManualLocation,
		isRebooking,
		typeLocalName,
		bookingNumber,
	} = bookingData;

	const params = {
		specialty_code: String(specialtyCode),
		clinic_code: isTelemedicine ? TELEMEDICINE_INFO.code : unitCode,
		entryPointCode: Number(EntryPointCodeEnum.V2),
		subspecialty_code: subSpecialtyCode ?? '',
		appointment_number: isTelemedicine && isRebooking ? bookingNumber : undefined,
		cityName: isTelemedicine ? 'FORTALEZA' : cityName,
		stateCode: ufCode,
		typeLocalName: isManualLocation ? typeLocalName : TypeLocalNameEnum.CIDADE,
		providerId:
			(bookingData?.isFavoriteDoctorsFlow && bookingData?.professionalCode) || providerId,
	};

	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_DATES, params],
		queryFn: async ({signal}) => getHealthDates({signal, ...params}),
		enabled,
		staleTime: HEALTH_DATES_STALE_TIME,
	});
}

export {useGetHealthDatesQuery};
